import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const CustomerTestimonials = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const TestimonialsContent = [
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjVAFvZ7T7qOiJwJT8Xi47s8s2PJRqVho25AQdauOjyeWbyVRXWfDA=w60-h60-p-rp-mo-ba4-br100",
      userCompany: "/assests/images/logo-new.jpg",
      userName: "Rallabandi Karthik",
      userDesgination: "",
      userFrom: "Accelalpha",
      userTestimonial:
        "Eyantra has been an excellent vendor for us, providing welcome kits, Diwali gifts, and event giveaways. Their commitment to on-time delivery, exceptional product quality, and reliable service has always been impressive. A truly professional and dependable team to work with. Highly recommended!",
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a/ACg8ocKiPIS8mHsZnaxtC4ArokA3OvVABkhwZDgS_B2BSYYID2jaOA=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/3f-oil.png",
      userName: "Jagadeswar Reddy",
      userDesgination: "",
      userFrom: "3F oil",
      userTestimonial:
        "Our company recently worked with eYantra for customized corporate gifts, and we were highly impressed. The product quality, branding, and timely delivery exceeded our expectations. Leela and the team ensured a hassle-free experience, and we look forward to future collaborations",
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/h_logo.png",
      userName: "Alankrit Shinghal",
      userDesgination: "",
      userFrom: "Hyundai Mobis",
      userTestimonial: (
        <>
          <p>
            Whenever I am thinking about our stakeholders gifting, eYantra is
            the first name that comes into my mind. They made our quarterly
            trophies elegant.
          </p>
          <p>We really like their follow-ups and timely delivery.</p>
        </>
      ),
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/Alivecor.svg",
      userName: "Sagarika Bai",
      userDesgination: "",
      userFrom: "Alivecor",
      userTestimonial: (
        <p>
          I interacted with Sanjeet to help with Branded laptop bags for our
          company Alivecor in a short span and he and team gave us timely
          delivery and quality products. Thanks eYantra Team and special thanks
          to Sanjeet for the support.
        </p>
      ),
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "/assests/images/teksystems.svg",
      userName: "Jinesh r nair",
      userDesgination: "",
      userFrom: "TEK systems",
      userTestimonial: (
        <p>
          Thank you Sundeep and team from E-Yantra for providing us an enriching
          experience for our company Diwali Gifting. Looking forward to work
          with you on more occasions coming our way.
        </p>
      ),
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/cotiviti.png",
      userName: "Shashi Bonagiri",
      userDesgination: "",
      userFrom: "Cotiviti",
      userTestimonial: (
        <p>
          Whenever I am thinking about our stakeholders gifting, eYantra is the
          first name that comes into my mind. They made our quarterly trophies
          elegant. We really like their follow-ups and timely delivery.
        </p>
      ),
    },

    // -------------------------------
    // NEW TESTIMONIAL WITH VIEW MORE
    // -------------------------------
    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/testimonials-logos/Qualcomm@2x-8.png",
      userName: "Onkar Kaudki",
      userDesgination: "",
      userFrom: "Qualcomm",
      userTestimonial: ({ show }) => (
        <>
          <p>
            Really good quality products, branding and services for gifting to
            employees by eYantra. We recently purchased products from eYantra
            Hyderabad, were really impressed with their quality, branding,
            & attention to detail.
          </p>

          {show && (
            <>
              <p>
                The materials used and product branding were excellent. The
                greeting card design was also very good.
              </p>
              <p>
                Highly recommend eYantra Industries. Thank You Pratyusha and
                Pujala for supporting our employee appreciation event.
              </p>
            </>
          )}
        </>
      ),
    },

    {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/testimonials-logos/Pythian@2x-8.png",
      userName: "Gopi Kampa",
      userDesgination: "",
      userFrom: "Pythian",
      userTestimonial: ({ show }) => (
        <>
          <p>
            We recently purchased products from eYantra Industries Pvt Ltd,
            Hyderabad, and we are thoroughly impressed with their quality and
            attention to detail.
          </p>

          {show && (
            <>
              <p>
                Their customer service team is responsive and professional. The
                delivery was smooth and on time.
              </p>
              <p>
                We highly recommend eYantra Industries. Leela deserves special
                mention for her great support.
              </p>
            </>
          )}
        </>
      ),
    },
     {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/testimonials-logos/Satven@2x-8.png",
      userName: "Shiva Shanker",
      userDesgination: "",
      userFrom: "Satven",
      userTestimonial: (
        <>
          <p>
            I had given last minute order to srikar, but it was delivered before time. Thank you so much srikar, the quality was excellent, and the engraving was perfect. It arrived quickly and was packaged well.
          </p>

        </>
      ),
    },
     {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/testimonials-logos/Aparna@2x-8.png",
      userName: "Harsha Vardhan B",
      userDesgination: "",
      userFrom: "Aparna Enterprises",
      userTestimonial: (
        <>
          <p>
            eYantra really does a splendid job in our Dealer Diwali Gifting... 
            Extraordinary product and branding with timely delivery. 
            Thank You eYantra & Srikar 
          </p>

        </>
      ),
    },
     {
      userImg:
        "https://lh3.googleusercontent.com/a-/ALV-UjUs9kJdxfZHAmTBwRHkdxWl6Amo1I7lw_3DQrRWC60Sb99kGqT6=w60-h60-p-rp-mo-br100",
      userCompany: "../assests/images/testimonials-logos/IBS fulcro@2x-8.png",
      userName: "Neha Veralkar",
      userDesgination: "",
      userFrom: "IBS Fulcro",
      userTestimonial: (
        <>
          <p className="p-0 m-0">
            Interacted with Meena for the Diwali Gifting. She has listened to all my queries and Doubts and endless hamper changes. Very cooperative service. The Gifts were nice, and the service was pretty good. Their professionalism and accountability are commendable.
          </p>

        </>
      ),
    },
  ];

  return (
    <div className="container-fluid bgeYantra">
      <Container className="pt-5 pb-5">
        <h2 id="subHeading">Customer Testimonials</h2>

        <Swiper
          spaceBetween={30}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation={true}
          loop={true}
          modules={[Autoplay, Pagination, Navigation]}
          breakpoints={{
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 3 },
          }}
          className="mySwiper"
        >
          {TestimonialsContent.map((item, index) => {
            const isExpandable = typeof item.userTestimonial === "function";
            const isOpen = openIndex === index;

            return (
              <SwiperSlide key={index}>
                <div className="testimonials h-100 rounded p-3 d-flex flex-column justify-content-center">
                  
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <p className="textSecondary fs-medium fw-bold mb-1">
                        {item.userName}
                      </p>
                    </div>
                    <div>
                      <img
                        src={item.userCompany}
                        alt="Company Logo"
                        width="60"
                        loading="lazy"
                      />
                      <p className="fs-12 text-center">
                        From: <b>{item.userFrom}</b>
                      </p>
                    </div>
                  </div>

                  <div className="border-top pt-3 fs-14">
                    {isExpandable
                      ? item.userTestimonial({ show: isOpen })
                      : item.userTestimonial}

                    {isExpandable && (
                      <span
                        className="fw-bold d-block m-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => toggle(index)}
                      >
                        {isOpen ? "View Less" : "View More"}
                      </span>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Container>
    </div>
  );
};

export default CustomerTestimonials;
